import { render, staticRenderFns } from "./LotteryOffer.vue?vue&type=template&id=24ea68cb&scoped=true&"
import script from "./LotteryOffer.vue?vue&type=script&lang=js&"
export * from "./LotteryOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea68cb",
  null
  
)

export default component.exports